<template>
    <div>
        <AppToolbar :items="navigations" title="Apps" @icon-click="drawer=!drawer"></AppToolbar>
        <AppSidebar :drawerProp="drawer" :items="navigations"></AppSidebar>
        <router-view></router-view>
    </div>
</template>

<script>
    import AppToolbar from '@/components/@global/AppToolbar';
    import AppSidebar from '@/components/@global/AppSidebar';
    export default {
        components: {
            AppToolbar,
            AppSidebar
        },

        data() {            
            return {
                drawer: false,
                navigations: [
                    {
                        title: "Manager",
                        icon: "pets",
                        path: "/app/manager"
                    },
                    {
                        title: "Teacher",
                        icon: "record_voice_over",
                        path: "/app/teacher"
                    },
                    {
                        title: "Student",
                        icon: "school",
                        path: "/app/student"
                    },
                    {
                        title: "Add new app",
                        icon: "add",
                        path: "/app/add"
                    }
                ]
            }
        },

    }
</script>

<style scoped>

</style>